<template>
  <l-dialog
    :auto-close="false"
    :disable-confirm="currentId === selectId"
    @cancel="cancel"
    @confirm="confirm"
    title="切换机构"
    v-model="show"
    width="350px"
  >
    <slot name="activator" slot="activator"></slot>
    <v-layout align-center class="pb-5 pt-2" justify-center v-if="getLoading">
      <v-progress-circular color="primary" indeterminate size="50" width="2"></v-progress-circular>
    </v-layout>
    <v-list v-else>
      <v-divider></v-divider>
      <template v-for="ins in insItems">
        <v-list-tile :key="ins.id" @click="select = ins" ripple>
          <v-list-tile-avatar>
            <v-icon :color="selectId === ins.id ? 'primary':''" small>$vuetify.icons.institution</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content :class="selectId === ins.id ? 'primary--text':''">{{ins.name}}</v-list-tile-content>
          <v-list-tile-action v-if="selectId === ins.id">
            <v-icon color="primary">mdi-check</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider :key="ins.id + 'd'"></v-divider>
      </template>
    </v-list>
    <v-alert :value="true" type="warning" v-if="select && currentId !== selectId">
      切换机构将清除所有未保存的操作！
    </v-alert>
  </l-dialog>
</template>

<script>
export default {
  name: 'institutionDialog',
  data: () => ({
    show: false,
    select: null,
    getLoading: false,
    submitLoading: false,
    insItems: []
  }),
  computed: {
    current () {
      return this.$store.getters['login/institution']
    },
    currentId () {
      return this.current && this.current.id
    },
    selectId () {
      return this.select && this.select.id
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.select = this.current
        console.log('set sekect', this.select, this.current)
        this.getInstitutions()
      }
    }
  },
  methods: {
    async confirm () {
      console.log('confirm', this.select)
      try {
        this.submitLoading = true
        await this.$store.dispatch('login/switchCurrentIns', this.select)
        this.changeSystemOption()
        this.show = false
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.submitLoading = false
      }
    },
    cancel () {
      console.log('cancel')
      this.show = false
    },
    changeSystemOption () {
      console.log('system institution switch to', this.current)
      this.$L.cfg.appName.subTitle = this.current.name
    },
    async getInstitutions () {
      try {
        this.getLoading = true
        this.insItems = await this.$store.dispatch('login/getAvailableIns')
        console.log('get ins', this.insItems)
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.getLoading = false
      }
    }
  },
}
</script>

<style scoped>

</style>
